var render = function render(){var _vm=this,_c=_vm._self._c;return _c('banners',{attrs:{"type":"crypto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }